import { Typography } from '@mui/material'
import { add, isBefore, sub } from 'date-fns'

interface CertificateStatusProps {
  expirationDate: string
}

export function CertificateStatus({ expirationDate }: CertificateStatusProps) {
  const isExpiring = isBefore(expirationDate, add(new Date(), { days: 30 }))
  const isExpired = isBefore(expirationDate, sub(new Date(), { days: 1 }))

  if (isExpired) {
    return (
      <Typography component="span" color="error">
        Vencido
      </Typography>
    )
  }

  if (isExpiring) {
    return (
      <Typography component="span" color="warning">
        Vencendo
      </Typography>
    )
  }

  return (
    <Typography component="span" color="success">
      Ativo
    </Typography>
  )
}
